import { CONTENT_TYPE_ID, NG_LAYER_TYPES } from '../../../constants';
import { arraySortAscendingFunction } from '../../../services/utilities';

export const getters = {
    getAllOrderedFeedbacks: state => {
        return state.feedbacks.sort((a, b) => a.order - b.order);
    },
    getFeedbackById: state => (_id) => state.feedbacks.find(({ id }) => _id === id),
    getFeedbacks: state => {
        return state.feedbacks.filter(feedback => feedback.data.feedbackType.contentTypeId === CONTENT_TYPE_ID.FEEDBACK);
    },
    getActivatedFeedbacks: state => {
        return state.layers.filter(layer => layer.type === NG_LAYER_TYPES.FEEDBACK && layer.active);
    },
    getMeasurements: state => {
        return state.feedbacks.filter(feedback => feedback.data.feedbackType.contentTypeId === CONTENT_TYPE_ID.MEASUREMENT);
    },
    getEditableFeedbacksByContentTypeId: (state) => (contentTypeId) => {
        return state.feedbacks
            .filter(feedback => (
                feedback.data.userEdit &&
                !feedback.data.feedbackType.useInWebTheme &&
                feedback.data.feedbackType.contentTypeId === contentTypeId
            ))
            .map(({ name, id }) => ({ value: id, layerId: '0', text: name, type: 'feedback' }))
            .sort(arraySortAscendingFunction('text'));
    },
    getCheckForImportFeedbackCancelToken: state => state.importFeedbackCancelToken
};
